export const fgFieldSchema =  [
    {
        "type": "fgbutton",
        "label": " new button ",
        "class": "btn-danger",
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgcard",
        "name": "card",
        "icon": "fa fa-square-o",
        "class": "card-default",
        "header": true,
        "heading": " some heading",
        "config": true,
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgtabs",
        "name": "Tabs",
        "icon": "fa fa-columns",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgDynamicTabs",
        "name": "Dynamic Tabs",
        "icon": "fa fa-columns",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgTimeLine",
        "name": "Timeline",
        "icon": "fa fa-clock",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgInnerForm",
        "name": "Inner Form",
        "icon": "fa fa-columns",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgColorPalette",
        "name": "Color Palette",
        "icon": "fa fa-columns",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgDataMap",
        "name": "Data Map",
        "icon": "fa fa-columns",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"INPUT"
    },
    {
        "type": "fgSearchBtn",
        "name": "Search Button",
        "icon": "fa fa-search",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"ACTIONS"
    },
    {
        "type": "fgCancelBtn",
        "name": "Cancel Button",
        "icon": "fa fa-close",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"ACTIONS"
    },
    {
        "type": "fgtabitem",
        "name": "Tab",
        "children": [],
        "category":"GENERAL"
    },
    {
        "type": "fgStepper",
        "name": "Stepper",
        "icon": "fa fa-columns",
        "config": true,
        "options": { },
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgStepperItem",
        "name": "Stepper",
        "children": [],
        "fgStepperForm": {},
        "category":"LAYOUT"
    } ,
    {
        "type": "fgDynamicDataGrid",
        "name": "Data Grid",
        "icon": "fa fa-bars",
        "config": false,
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fginput",
        "input": "text",
        "name": "Text",
        "label": "Text",
        "icon": "fa fa-terminal",
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "uId": "cf8f4011-fdc0-436c-9b1e-4453e9df664ed",
        "category":"INPUT"
    },
    {
        "type": "fgvalue",
        "input": "value",
        "name": "Field Value",
        "label": "Field Value",
        "icon": "fa fa-terminal",
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgtextarea",
        "name": "Text Area",
        "label": "Text Area",
        "icon": "fa fa-font",
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fginput",
        "input": "number",
        "name": "Number",
        "uId": "cf8f4011-fdc0-436c-9b1e-4453e9gg44ed",
        "icon": "fa fa-hashtag",
        "label": "Number Field",
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fginput",
        "input": "date",
        "name": "Date",
        "icon": "fa fa-calendar-o",
        "label": "Date Field",
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgcheckbox",
        "label": "Check Box",
        "name": "Check Box",
        "icon": "fa fa-check-square",
        "labelPos": "left",
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    //{
    //     "type": "fgcheckboxgroup",
    //     "label": "Check Box Group",
    //     "name": "Check Box Group",
    //     "icon": "fa fa-plus-square",
    //     "labelPos": "left",
    //     "values": [],
    //     "validation": {},
    //     "condition": {},"isCoreConfig": true,
    //     "category":"INPUT"
    // },
    {
        "type": "fgradio",
        "label": "Radio",
        "name": "Radio Button",
        "icon": "fa fa-dot-circle-o",
        "labelPos": "left",
        "values": [],
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgselect",
        "label": "Select",
        "name": "Select Drop down",
        "icon": "fa fa-th-list",
        "values": [],
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgSelectListBox",
        "label": "Select List Box",
        "name": "Select List Box",
        "icon": "fa fa-th-list",
        "values": [],
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgLayoutDesigner",
        "label": "Layout Designer",
        "name": "Layout Designer",
        "icon": "fa fa-th-list",
        "values": [],
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgdbcardinfo",
        "subtype": "iconleft",
        "cat": "Icon",
        "name": "Info card",
        "icon": "fa fa-square-o",
        "config": true,
        "cardIcon": "fa fa-flag",
        "iconBg": "fg-bg-blue-50",
        "iconFontColor": "fc-white",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgdbcardinfo",
        "subtype": "imgleft",
        "cat": "Image",
        "name": "Info card",
        "icon": "fa fa-square-o",
        "config": true,
        "imgBg": "fg-bg-blue-50",
        "cardImg": "resources/img/illustrations/svg/empty_xct9.svg",
        "iconFontColor": "fc-white",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgdbcardinfo",
        "subtype": "icontop",
        "cat": "Icon",
        "name": "Info card 2",
        "icon": "fa fa-square-o",
        "config": true,
        "cardIcon": "fa fa-flag",
        "iconBg": "fg-bg-blue-50",
        "iconFontColor": "fc-white",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgdbcardinfo",
        "subtype": "imgtop",
        "name": "Info card 2",
        "cat": "Image",
        "icon": "fa fa-square-o",
        "config": true,
        "iconBg": "fg-bg-blue-50",
        "cardImg": "resources/img/illustrations/svg/empty_xct9.svg",
        "iconFontColor": "fc-white",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgdbcardinfo",
        "subtype": "plain",
        "name": "Info card 2",
        "cat": "plain",
        "icon": "fa fa-square-o",
        "config": true,
        "cardIcon": "fa fa-flag",
        "iconFontColor": "fc-white",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgword",
        "subtype": "h1",
        "cat": "HEADING",
        "name": "Heading 1",
        "text": "Sentance",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgword",
        "subtype": "h2",
        "cat": "HEADING",
        "icon": "fa fa-square-o",
        "name": "Heading 1",
        "text": "Sentance",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgword",
        "subtype": "h3",
        "cat": "HEADING",
        "icon": "fa fa-square-o",
        "name": "Heading 1",
        "text": "Sentance",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgword",
        "subtype": "h4",
        "cat": "HEADING",
        "icon": "fa fa-square-o",
        "name": "Heading 1",
        "text": "Sentance",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgword",
        "subtype": "h5",
        "cat": "HEADING",
        "icon": "fa fa-square-o",
        "name": "Heading 1",
        "text": "Sentance",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgword",
        "subtype": "h6",
        "cat": "HEADING",
        "icon": "fa fa-square-o",
        "name": "Heading 1",
        "text": "Sentance",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgword",
        "subtype": "p",
        "cat": "HEADING",
        "icon": "fa fa-square-o",
        "name": "Paragraph",
        "text": "Sentance",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgword",
        "subtype": "Q",
        "cat": "QUOTE",
        "icon": "fa fa-square-o",
        "name": "Blockquote",
        "text": "Self contained, independent components assembled to achieve and extend data exchange, transformation and presentment needs",
        "footerText": "From Bluescope Tech",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgprogresscard",
        "subtype": "2field",
        "cat": "fields",
        "name": "Progress card",
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgchart",
        "subtype": "pie",
        "cat": "chart",
        "icon": "  fa fa-pie-chart",
        "name": "Pie Chart",
        "options": { legend: {} },
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgchart",
        "subtype": "doughnut",
        "cat": "chart",
        "icon": "fa fa-square-o",
        "name": "Doughnut Chart",
        "options": { legend: {} },
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgchart",
        "subtype": "polarArea",
        "cat": "chart",
        "icon": "fa-polar-chart",
        "name": "Polar area Chart",
        "options": { legend: {} },
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgchart",
        "subtype": "bar",
        "cat": "chart",
        "icon": "fa fa-bar-chart",
        "name": "Bar Chart",
        "options": { legend: {} },
        "barColor": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgchart",
        "subtype": "line",
        "cat": "chart",
        "icon": "fa fa-line-chart",
        "name": "Line Chart",
        "options": { legend: {} },
        "lineColor": {},
        "fillColor": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgchart",
        "subtype": "pie",
        "cat": "scorechart",
        "icon": "  fa fa-pie-chart",
        "name": "score Pie Chart",
        "options": { legend: {} },
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgListPage",
        "subtype": "list",
        "cat": "fgListPage",
        "icon": "  fa fa-list",
        "name": "List Page",
        "options": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgchart",
        "subtype": "doughnut",
        "cat": "scorechart",
        "icon": "fa fa-square-o",
        "name": "score Doughnut Chart",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgchart",
        "subtype": "polarArea",
        "cat": "scorechart",
        "icon": "fa-polar-chart",
        "name": "score Polar area Chart",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgchart",
        "subtype": "bar",
        "cat": "scorechart",
        "icon": "fa fa-bar-chart",
        "name": "score Bar Chart",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgchart",
        "subtype": "line",
        "cat": "scorechart",
        "icon": "fa fa-line-chart",
        "name": "score Line Chart",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgdatagrid",
        "subtype": "Q",
        "cat": "QUOTE",
        "icon": "fa fa-table",
        "name": "Data Grid",
        "text": "Table Grids",
        "heading": "Data Grid",
        "footerText": "From Bluescope Tech",
        "condition": {},
        "isCoreConfig": true,
        "label": "Data Grid",
        "category":"LAYOUT"
    },
    {
        "type": "fgparty",
        "subtype": "Q",
        "icon": "fa fa-user",
        "name": "Organization Field",
        "text": "Organization ",
        "heading": "Organization Field",
        "footerText": "From Bluescope Tech",
        "label": "Fg Party",
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgbusinesscode",
        "subtype": "Q",
        "icon": "fa fa-user",
        "name": "BusinessCode Field",
        "text": "BusinessCode Field",
        "heading": "BusinessCode Field",
        "footerText": "From Bluescope Tech",
        "label": "BusinessCode",
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgAttachmentConfiguration",
        "subtype": "Q",
        "icon": "fa fa-file",
        "name": "Attachment",
        "text": "Attachment",
        "heading": "Attachment",
        "footerText": "From Bluescope Tech",
        "label": "Attachment",
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgImagePicker",
        "subtype": "Q",
        "icon": "fa fa-image",
        "name": "FG Image Picker",
        "text": "FG Image Picker",
        "heading": "FG Image Picker",
        "footerText": "From Bluescope Tech",
        "label": "Image Picker",
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },

    {
        "type": "fgSingleActionBuilder",
        "subtype": "Q",
        "icon": "fa fa-file",
        "name": "FG Single Action",
        "text": "FG Single Action",
        "heading": "FG Single Action",
        "footerText": "From Bluescope Tech",
        "label": "Action Builder",
        "condition": {},
        "isCoreConfig": true,
        "category":"ACTIONS"
    },
    {
        "type": "fgscore",
        "subtype": "simple",
        "icon": "fa fa-bar-chart",
        "name": "Simple Score card",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgscore",
        "subtype": "single",
        "icon": "fa fa-1",
        "name": "Single Score card",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgscore",
        "subtype": "table",
        "icon": "fa fa-bar-chart",
        "name": "Score Table",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgscore",
        "subtype": "chart",
        "icon": "fa fa-bar-chart",
        "name": "Score with Chart",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgscore",
        "subtype": "chartinline",
        "icon": "fa fa-bar-chart",
        "name": "Score with Inline chart",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgConversationBuilder",
        "subtype": "Q",
        "icon": "fa fa-chat",
        "name": "FG Conversation",
        "text": "FG Conversation",
        "heading": "FG Conversation",
        "footerText": "From Bluescope Tech",
        "label": "Conversation Builder",
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgActionBlocks",
        "subtype": "actionBottom",
        "cat": "singleAction",
        "icon": "  fa fa-plus",
        "name": "Single Actions",
        "options": { legend: {} },
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgActionBlocks",
        "subtype": "actionSide",
        "cat": "singleAction",
        "icon": "  fa fa-plus",
        "name": "Single Actions",
        "options": { legend: {} },
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgActionBlocks",
        "subtype": "actionList",
        "cat": "singleAction",
        "icon": "  fa fa-plus",
        "name": "Single Actions",
        "options": { legend: {} },
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgActionBlocks",
        "subtype": "fgAction",
        "cat": "multipleAction",
        "icon": "  fa fa-plus",
        "name": "Multiple Actions",
        "options": { legend: {} },
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgActionBlocks",
        "subtype": "fgMultipleCard",
        "cat": "multipleAction",
        "icon": "  fa fa-plus",
        "name": "Multiple Card",
        "options": { legend: {} },
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgvaluetable",
        "name": "Value Table",
        "icon": "fa fa-table",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgDataList",
        "subtype": "actionList",
        "icon": "  fa fa-list",
        "name": "Data List",
        "options": { legend: {} },
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgcarousel",
        "name": "Image Carousel",
        "icon": "fa fa-picture-o",
        "config": true,
        "carImages": [],
        "carActions": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgsection",
        "name": "Section",
        "icon": "fa fa-bars",
        "config": false,
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgyear",
        "name": "Year Picker",
        "icon": "fa fa-calendar-o",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgmonth",
        "name": "Month Picker",
        "icon": "fa fa-calendar-o",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgmonthdate",
        "name": "Month Day Picker",
        "icon": "fa fa-calendar-o",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgweek",
        "name": "Week Picker",
        "icon": "fa fa-calendar-o",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgweekday",
        "name": "Week Day Picker",
        "icon": "fa fa-calendar-o",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgquarter",
        "name": "Quarter Picker",
        "icon": "fa fa-calendar-o",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgdatedime",
        "name": "Date Dimension",
        "icon": "fa fa-calendar-o",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgolist",
        "subtype": "Ol",
        "name": "Ordered List",
        "icon": "fa fa-th-list",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"STATIC"
    },
    {
        "type": "fginput",
        "input": "pickerinput",
        "name": "Picker & Input",
        "label": "Picker & Input",
        "uId": "cf8f4011-fdc0-436c-9b1e-3353e9df44ed",
        "icon": "fa fa-caret-square-o-down",
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgkanban",
        "subtype": "chart",
        "icon": "fa fa-bar-chart",
        "name": "Score with Chart",
        "condition": {},
        "isCoreConfig": true,
        "category":"BLOCKS"
    },
    {
        "type": "fgbuttonaction",
        "subtype": "formaction",
        "icon": "fa fa-plus",
        "name": "Fg Button",
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgbuttonaction",
        "subtype": "listaction",
        "icon": "fa fa-list",
        "name": "Fg Button",
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgwysiwyg",
        "subtype": "fgwysiwyg",
        "icon": "fa fa-newspaper-o",
        "name": "Fg WYSIWYG",
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgcronexpression",
        "subtype": "fgcronexpression",
        "icon": "fa fa-list",
        "name": "Fg Cron Expression",
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgbuttonaction",
        "subtype": "fgprocessbutton",
        "icon": "fa fa-list",
        "name": "Fg Button",
        "action": "Process",
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fguserdetail",
        "subtype": "fguserdetail",
        "icon": "fa fa-list",
        "name": "User Details",
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgcarddetail",
        "subtype": "fgcarddetail",
        "icon": "fa fa-list",
        "name": "Card",
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgCardheader",
        "name": "cardheader",
        "icon": "fa fa-square-o",
        "class": "card-default",
        "header": true,
        "heading": " some heading",
        "config": true,
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgcustomcontainer",
        "name": "Custom Container",
        "icon": "fa fa-square-o",
        "class": "card-default",
        "header": true,
        "heading": " some heading",
        "config": true,
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgbuttonaction",
        "subtype": "customaction",
        "icon": "fa fa-list",
        "name": "Fg Button",
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgModalDialog",
        "name": "Modal Dialog",
        "icon": "fa fa-square-o",
        "class": "card-default",
        "config": true,
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgModalHeader",
        "name": "Modal Header",
        "icon": "fa fa-square-o",
        "config": true,
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgModalBody",
        "name": "Modal Body",
        "icon": "fa fa-square-o",
        "config": true,
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"

    },
    {
        "type": "fgModalFooter",
        "name": "Modal Footer",
        "icon": "fa fa-square-o",
        "config": true,
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"

    },
    // {
    //     "type": "fgRadioButtonGroup",
    //     "label": "Radio Group",
    //     "name": "Radio Group",
    //     "icon": "fa fa-plus-square",
    //     "labelPos": "left",
    //     "values": [],
    //     "validation": {},
    //     "condition": {}, "isCoreConfig": true,
    //    "category":"INPUT"
    // },
    {
        "type": "fghtml",
        "subtype": "html",
        "cat": "HTML",
        "icon": "fa fa-square-o",
        "name": "HTML",
        "text": "Rich Text",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgimage",
        "subtype": "Image",
        "cat": "Image",
        "name": "Image",
        "icon": "fa fa-img",
        "label": "Image",
        "text": "Image",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgtable",
        "subtype": "Table",
        "cat": "Table",
        "name": "Table",
        "icon": "fa fa-img",
        "label": "Table",
        "text": "Table",
        "tableColumns": [],
        "tableRows": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgvideo",
        "subtype": "Video",
        "cat": "Video",
        "name": "Video",
        "icon": "fa fa-img",
        "label": "Video",
        "text": "Video",
        "condition": {},
        "isCoreConfig": true,
        "category":"STATIC"
    },
    {
        "type": "fgiconselector",
        "subtype": "fgiconselector",
        "cat": "fgiconselector",
        "name": "iconselector",
        "icon": "fa fa-img",
        "label": "iconselector",
        "text": "iconselector",
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgContextFilter",
        "subtype": "fgContextFilter",
        "cat": "fgContextFilter",
        "name": "Context Filter",
        "label": "Context Filter",
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgrange",
        "name": "Range",
        "uId": "cf8f4011-fvg0-436c-9b1e-4453e9df44ed",
        "label": " Range Slider",
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgFactedContainer",
        "label": "Faced Search",
        "name": "Faced Search",
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgDetailSwitch",
        "label": "Detail Switch",
        "name": "Detail Switch",
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fginputscale",
        "name": "Scale",
        "label": "Input Scale",
        "uId": "cf8f4011-fdc0-436c-9b1e-4h66e9df44ed",
        "icon": "fa fa-terminal",
        "scales": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgcardlayout",
        "name": "Card Layout",
        "icon": "fa fa-columns",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgcardContainer",
        "name": "Card Container",
        "icon": "fa fa-columns",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgCardHeader",
        "name": "Card Header",
        "icon": "fa fa-square-o",
        "config": true,
        "class": "card-header",
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgCardBody",
        "name": "Card Body",
        "icon": "fa fa-square-o",
        "config": true,
        "class": "card-body",
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fgCardFooter",
        "name": "Card Footer",
        "icon": "fa fa-square-o",
        "config": true,
        "class": "card-footer",
        "children": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"GENERAL"
    },
    {
        "type": "fglogincontainer",
        "name": "Login Container",
        "icon": "fa fa-list",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgCompareScreen",
        "name": "Compare",
        "icon": "fa fa-columns",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgiframecontainer",
        "name": "Iframe Container",
        "icon": "fa fa-desktop",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgflexbox",
        "name": "Flexbox",
        "icon": "fa fa-desktop",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"GENERAL"
    },
    {
        "type": "fgOTP",
        "name": "OTP",
        "icon": "fa fa-desktop",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "category":"INPUT"
    },
    {
        "type": "fgStepIndicator",
        "name": "Step Indicator",
        "icon": "fa fa-desktop",
        "config": true,
        "condition": {},
        "isCoreConfig": true,
        "children": [],
        "stepList": [],
        "category":"LAYOUT"
    },
    {
        "type": "fgprofile",
        "subtype": "customerparty",
        "icon": "fa fa-user",
        "name": "Profile",
        "text": "Profile",
        "footerText": "From Bluescope Tech",
        "label": "Profile",
        "field": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgtooltip",
        "subtype": "fgtooltip",
        "icon": "fa fa-user",
        "name": "Tooltip",
        "footerText": "From Bluescope Tech",
        "field": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgFileUploader",
        "name": "File Uploader",
        "icon": "fa fa-desktop",
        "config": true,
        "condition": {},
        "children": [],
        "stepList": [],
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgButtonSelector",
        "name": "Button Selector",
        "icon": "fa fa-desktop",
        "config": true,
        "condition": {},
        "children": [],
        "stepList": [],
        "isCoreConfig": true,
        "category":"ACTIONS"
    },
    {
        "type": "fgModelFieldPicker",
        "name": "Model Field Picker",
        "icon": "fa fa-desktop",
        "config": true,
        "condition": {},
        "children": [],
        "stepList": [],
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgBottomNavigationBar",
        "name": "Bottom Navigation Bar",
        "icon": "fa fa-desktop",
        "config": true,
        "condition": {},
        "children": [],
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgCopyReference",
        "subtype": "fgCopyReference",
        "icon": "fa fa-user",
        "name": "Reference Component",
        "footerText": "From Bluescope Tech",
        "field": [],
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgProcessflowTimeline",
        "name": "Processflow Timeline",
        "icon": "fa fa-clock-o",
        "config": true,
        "condition": {},
        "children": [],
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgDataContainer",
        "name": "Data Container",
        "icon": "fa fa-columns",
        "config": true,
        "condition": {},
        "children": [],
        "stepList":[],
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgCaptcha",
        "name": "Captcha",
        "icon": "fa fa-C",
        "config": true,
        "condition": {},
        "children": [],
        "stepList":[],
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgExpansion",
        "name": "Expansion Panel",
        "icon": "fa fa-expand",
        "config": true,
        "condition": {},
        "children": [],
        "stepList":[],
        "isCoreConfig": true,
        "category":"INPUT"
    },
    {
        "type": "fgDynamicDataTable",
        "name": "Dynamic Data Table",
        "icon": "fa fa-th-list",
        "values": [],
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"LAYOUT"
    },
    {
        "type": "fgComponentOTP",
        "name": "Custom OTP",
        "icon": "fa fa-message",
        "values": [],
        "validation": {},
        "condition": {},
        "isCoreConfig": true,
        "category":"INPUT"
    },
]

export const queryServiceApiStructure = {
  "filterClause": {
    "ID": "894d00d5-4cba-4ddc-b683-45ed8827bb09",
    "VERSION_ID": 1,
    "TYPE_CODE": "BS_MASTERS",
    "SUB_TYPE_CODE": "BS_CURRENCY",
    "includeAllLink": true,
    "ROLES": "all"
  },
  "typeCode": "BS_MASTERS",
  "subTypeCode": "BS_CURRENCY",
  "action": "findByIdentifier",
  "actionCode": "AllTask"
}